<template>
	<div>
		<header-section icon="" title="Historial de beca">
			<template slot="buttons">
				<el-button
						size="medium"
						type="danger"
						icon="el-icon-arrow-left"
						@click="$router.push('/inicio')">
					Regresar
				</el-button>
			</template>
		</header-section>


		<el-table v-if="isSalvadorProgram()"
				:data="tableData"
				border
				style="width: 100%">
			<el-table-column
					align="center"
					label="Nº de pago"
					min-width="100">
				<template slot-scope="scope">
					<div>
						{{ scope.$index + 1 }}
					</div>
				</template>
			</el-table-column>
			<el-table-column
					prop="cat_status.name"
					label="Estatus"
					min-width="100">
			</el-table-column>
			<el-table-column
					prop="date"
					label="Fecha de pago"
					min-width="100">

				<template slot-scope="scope">
					<div>
						{{ scope.row.dispersionDate | formatDate }}
					</div>
				</template>
			</el-table-column>
			<el-table-column
					label="Monto(USD)"
					min-width="100">
				<template slot-scope="scope">
					<div>
						{{ scope.row.amountSent | currency }}
					</div>
				</template>
			</el-table-column>

			<el-table-column
					label="Monto a Dispersar (Lempiras)"
					min-width="100" v-if="isHondurasProgram()">
				<template slot-scope="scope">
					<div>
						{{ scope.row.dispersedAmount | currency }}
					</div>
				</template>
			</el-table-column>
			<!--
			<el-table-column
					prop="location"
					label="Vinculado en"
					min-width="100">
			</el-table-column>
			-->
		</el-table>
		<el-table v-else
				:data="tableData"
				border
				style="width: 100%">
			<el-table-column
					align="center"
					label="Nº de pago"
					min-width="100">
				<template slot-scope="scope">
					<div>
						{{ scope.$index + 1 }}
					</div>
				</template>
			</el-table-column>
			<!-- <el-table-column
					prop="cat_status.name"
					label="Estatus"
					min-width="100">
			</el-table-column> -->
			<el-table-column
					prop="date_time_created"
					label="Fecha de pago"
					min-width="100">

				<template slot-scope="scope">
					<div>
						{{ scope.row.date_time_created }}
					</div>
				</template>
			</el-table-column>
			<el-table-column
					label="Monto(USD)"
					min-width="100">
				<template slot-scope="scope">
					<div>
						{{ scope.row.payment_amount | currency }}
					</div>
				</template>
			</el-table-column>

			<el-table-column
					label="Monto a Dispersar (Lempiras)"
					min-width="100" v-if="isHondurasProgram()">
				<template slot-scope="scope">
					<div>
						{{ scope.row.coupon_amount | currency }}
					</div>
				</template>
			</el-table-column>
			<!--
			<el-table-column
					prop="location"
					label="Vinculado en"
					min-width="100">
			</el-table-column>
			-->
		</el-table>

	</div>
</template>


<script>
	const HeaderSection = _ => import(/* webpackChunkName: "js/split/HeaderSection" */'@/components/partials/HeaderSection');
	import programMixin from '@/mixins/programMixin';

	export default {

		components: {
			HeaderSection
		},
        mixins:[programMixin],
		data() {
			return {
				tableData: [],
			}
		},
		methods: {
			showLoading(msg, showSpinner) {
				this.loading = true;
				if (showSpinner) {
					this.$store.dispatch(
						"loading/spinner",
						{msg: msg, status: true},
						{root: true}
					);
				}
			},
			hideLoading(showSpinner) {
				this.loading = false;
				if (showSpinner) {
					this.$store.dispatch("loading/spinner", {}, {root: true});
				}
			},
			iniService() {
				this.showLoading();
				let params = {};
				let url = '/api/people-advisor/get-my-payments';
				axios.get(`${url}`, {params: params}).then((res) => {
					this.hideLoading();
					this.loaded = true;
					this.tableData = res.data.data;

				}).catch((err) => {
					this.hideLoading();
					let msg = 'No se pudo completar la acción';
					if (err.response &&
						err.response.data &&
						err.response.data.message
						&& err.response.status == 400) {
						msg = err.response.data.message;
					}
					this.$store.dispatch('notifications/error', {msg: msg}, {root: true});

				});

			}
		},
		created() {
			this.iniService();
		}
	}
</script>

<style scoped>

</style>
